import styled from 'styled-components';
import { PALETTE_COLORS, SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: flex;
    justify-content: center;
    width: 100%;
    background: ${PALETTE_COLORS.PRIMARY_900};
  `,
    PageContent: styled.div `
    position: relative;
    display: flex;
    flex-direction: column;

    width: 100%;
    max-width: 730px;
    height: ${(props) => `${props.height}px`};
    overflow-y: auto;
    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};
  `,
};
